import { Route, Switch } from 'react-router-dom';
import { StyledSubNavigation } from './styled';
import { useAccessibleRoutes } from './hooks/useAccessibleRoutes';
import { SubNavWrapper } from '../../styled';

const BusinessPage = ({ access }) => {
  const accessibleSubroutes = useAccessibleRoutes(access);

  return (
    <>
      <SubNavWrapper>
        <StyledSubNavigation
          small
          id="sectionnav"
          routes={accessibleSubroutes}
        />
      </SubNavWrapper>
      <Switch>
        {Object.entries(accessibleSubroutes).map(([key, route]) => {
          const Component = route.component;
          return (
            <Route
              key={key}
              path={route.path}
              exact={route.exact !== false}
              component={route.component}
            >
              <Component access={access} />
            </Route>
          );
        })}
      </Switch>
    </>
  );
};

export default BusinessPage;
